<div class="container d-flex justify-content-center align-items-center">
  @if (!updateAvailable) {
    <div class="error text-center">
      <div class=" error__text--number">{{"ERRORS.PAGE_NOT_ALLOWED.CODE" | translate}}</div>
      <div class="error__text--big">{{"ERRORS.PAGE_NOT_ALLOWED.BIG" | translate}}</div>
      <div class="error__text--small">{{"ERRORS.PAGE_NOT_ALLOWED.SMALL" | translate}}</div>
      @if (isNspaceAdmin) {
        <div class="text-center"><a [href]="sonataUrl">Sonata</a></div>
      }
    </div>
  } @else {
    <div class="error text-center">
      <app-loader [loading]="true" [cssClasses]="'loader--relative'" />
      <div class=" error__text--big">{{"ERRORS.PAGE_NOT_ALLOWED.UPDATING" | translate}}</div>
    </div>
  }
</div>
